import * as React from "react";
import { SVGProps } from "react";

const KnifeAndForkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 32" fill="none" {...props}>
    <path
      fill="#fff"
      d="M14.667 20.666H18a.667.667 0 0 0 .667-.667c-.09-10.4-2.196-19.333-4-19.333v30.667"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M13.967.667a.7.7 0 0 1 .7-.7c.525 0 .932.32 1.214.644.293.338.557.796.797 1.326.482 1.064.93 2.56 1.316 4.349.775 3.586 1.328 8.468 1.372 13.708V20A1.367 1.367 0 0 1 18 21.367h-2.633v9.966a.7.7 0 1 1-1.4 0V.668Zm1.4 19.3h2.6c-.047-5.145-.592-9.914-1.342-13.386-.377-1.745-.8-3.132-1.223-4.067a8.154 8.154 0 0 0-.035-.078v17.53ZM1.333-.033a.7.7 0 0 1 .7.7v6.666a3.3 3.3 0 1 0 6.6 0V.667a.7.7 0 1 1 1.4 0v6.666a4.7 4.7 0 0 1-9.4 0V.667a.7.7 0 0 1 .7-.7Z"
      clipRule="evenodd"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M5.335-.033a.7.7 0 0 1 .7.7v30.667a.7.7 0 0 1-1.4 0V.666a.7.7 0 0 1 .7-.7Z"
      clipRule="evenodd"
    />
  </svg>
);
export default KnifeAndForkIcon;
